import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';
import SanitizedHTML from 'react-sanitized-html';

const styles = theme => ({
  title: {
    fontFamily: '"Courier Prime", "Courier", serif',
  },
  element: {
    fontFamily: '"Courier Prime", "Courier", serif',
    "& a": {
      textDecoration: 'none',
      color: theme.palette.primary.main
    },
    "& div": {
      marginBottom: 10
    }
  }
});
  
class DetailElement extends Component {
  
  render() {
    
    const { element, elementData, classes } = this.props;
    
    let link = ( element.link_function && element.link_function(elementData) ) || null;
    let field_display;
    if (link != null) {
      field_display = 
        <React.Fragment>
          <Link to={{pathname: link}}> 
            {("" + elementData[element.data_field]).split('\n').map((item, key) => {
              return <span key={key}>{item}<br/></span>
            })}
          </Link>
        </React.Fragment>
    } else {
      field_display = 
        <React.Fragment>
          {("" + elementData[element.data_field]).split('\n').map((item, key) => {
              return (
                <SanitizedHTML html={ item } key={key}/>
              );
          })}
        </React.Fragment>
    }
    return (
      <div>
        <Typography variant="h6" className={classes.element_title} gutterBottom>
          {element.title}
        </Typography>
        
        <Typography variant="body1" className={classes.element} component="div" gutterBottom>
          {field_display}
        </Typography>
      </div>
    );

  }
}

DetailElement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DetailElement);

// WEBPACK FOOTER //
// ./src/Components/Layouts/AttackDetails.js
